import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m20.607 7.44-.096-1.137a1.41 1.41 0 0 0-1.513-1.298L3.292 6.433A1.414 1.414 0 0 0 2.005 7.96l.193 2.142.644 7.304c.096.942.933 1.656 1.866 1.59l15.095-1.363a1.784 1.784 0 0 0 1.577-1.882s-.258-4.8-.87-5.746M2.713 15.815l18.538-1.688"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M21.38 15.75s-.258-4.8-.87-5.746C19.9 9.06 9.496 7.32 7.5 10.5c-1.255 1.98 1 3.5 3 2.5s-.59-4.922-5-4.5"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const CreditCardIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
